
{
  "nav": {
    "home": "首页",
    "explore": "探索",
    "about": "关于我们",
    "pricing": "价格方案",
    "submitListing": "提交列表",
    "login": "登录",
    "signup": "注册"
  },
  "userMenu": {
    "profile": "个人资料",
    "myListings": "我的列表",
    "favorites": "我的收藏",
    "referFriend": "推荐朋友",
    "paymentPending": "付款待处理",
    "logout": "登出",
    "upgradeToPremium": "升级至高级方案",
    "addListing": "新增列表"
  },
  "navigation": {
    "home": "首页",
    "explore": "探索",
    "about": "关于我们",
    "pricing": "价格方案",
    "login": "登录",
    "signup": "注册",
    "admin": "管理员"
  },
  "buttons": {
    "loading": "加载中..."
  },
  "profile": {
    "title": "个人资料设置",
    "description": "管理您的账户设置和偏好",
    "completeTitle": "完成您的个人资料",
    "completeDescription": "请完成您的个人资料以继续",
    "profileNotFound": "找不到个人资料",
    "tabs": {
      "profile": "个人资料",
      "security": "安全设置"
    },
    "loading": "加载个人资料中...",
    "completeAlert": "请完成您的个人资料以继续使用平台。",
    "form": {
      "title": "个人资料",
      "description": "在下方更新您的个人资料",
      "completeTitle": "完成您的个人资料",
      "completeDescription": "请填写您的个人资料以开始使用",
      "firstName": "名字",
      "lastName": "姓氏",
      "email": "电子邮件",
      "whatsappNumber": "WhatsApp 号码",
      "phoneNumber": "电话号码",
      "required": "*",
      "whatsappPlaceholder": "例如：+852 1234 5678",
      "phonePlaceholder": "例如：+852 1234 5678",
      "whatsappDescription": "您的 WhatsApp 号码供客户联系",
      "phoneDescription": "备用电话号码（可选）",
      "whatsappVerified": "已验证",
      "saving": "保存中...",
      "save": "保存更改",
      "complete": "完成个人资料"
    },
    "security": {
      "title": "安全设置",
      "description": "更新您的密码和安全偏好",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmPassword": "确认新密码",
      "passwordPlaceholder": "输入您的密码",
      "passwordRequirement": "密码至少需要8个字符",
      "updating": "更新中...",
      "update": "更新密码",
      "error": "错误",
      "success": "密码更新成功"
    }
  },
  "listings": {
    "title": "我的列表",
    "description": "管理和查看您的服务列表",
    "loading": "加载列表中...",
    "addNewListing": "新增列表",
    "empty": {
      "noListings": "未找到列表",
      "noListingsDescription": "您尚未创建任何列表。创建您的第一个列表以开始吸引客户。",
      "noFilteredListings": "所选状态未找到列表",
      "addListingButton": "创建列表",
      "viewAllButton": "查看所有列表"
    },
    "filters": {
      "all": "所有状态",
      "pending": "待审核",
      "approved": "已启用",
      "rejected": "已拒绝"
    },
    "alerts": {
      "freeTierTitle": "免费方案限制",
      "freeTierDescription": "您目前使用免费方案，只允许一个启用的列表。",
      "additionalListingsRejected": "额外的列表将自动被拒绝。",
      "upgradePrompt": "升级到高级方案以创建无限列表。",
      "upgradeButton": "升级到高级方案"
    }
  },
  "favorites": {
    "title": "我的收藏",
    "description": "您已保存的服务提供者",
    "loading": "加载收藏中...",
    "searchPlaceholder": "搜索您的收藏...",
    "providerCount": "显示 {{count}} 个{{provider}}",
    "provider_one": "提供者",
    "provider_other": "提供者",
    "noFavorites": {
      "title": "尚无收藏",
      "description": "保存您感兴趣的服务提供者以在此处查看",
      "button": "浏览服务"
    },
    "noSearchResults": {
      "title": "无搜索结果",
      "description": "尝试调整您的搜索词或清除搜索以查看所有收藏",
      "button": "清除搜索"
    }
  },
  "contact": {
    "providerWhatsappInquiryMessage": "你好，我在 WhatsGood HK 平台上看到了 {{serviceName}}。"
  },
  "footer": {
    "description": "与香港值得信赖的服务提供者联系",
    "quickLinks": "快速链接",
    "legal": "法律",
    "contact": "联系",
    "followUs": "关注我们",
    "copyright": "© 2025 WhatsGood HK.",
    "about": "关于",
    "aboutDescription": "与香港值得信赖的服务提供者联系",
    "home": "首页",
    "browseServices": "浏览服务",
    "listYourService": "刊登您的服务",
    "aboutUs": "关于我们",
    "pricing": "价格方案",
    "privacyPolicy": "隐私政策",
    "termsOfService": "服务条款",
    "getInTouch": "联系我们",
    "getInTouchDescription": "有问题或需要帮助？我们在这里为您提供协助。",
    "contactUs": "联系我们",
    "loadingContact": "加载联系方式...",
    "whatsappUs": "WhatsApp 联系",
    "whatsappInquiryMessage": "你好，我想咨询有关 WhatsGood HK 及本站的信息。",
    "shareViaWhatsapp": "通过 WhatsApp 分享"
  }
}
